export const SALES_MODE_LOGIN_STARTED = "SALES_MODE_LOGIN_STARTED";
export const SALES_MODE_LOGIN_SUCCEEDED = "SALES_MODE_LOGIN_SUCCEEDED";
export const SALES_MODE_LOGIN_FAILED = "SALES_MODE_LOGIN_FAILED";

export const SALES_MODE_POS_STARTED = "SALES_MODE_POS_STARTED";
export const SALES_MODE_POS_SUCCEEDED = "SALES_MODE_POS_SUCCEEDED";
export const SALES_MODE_POS_FAILED = "SALES_MODE_POS_FAILED";
